/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import {
  GetTaskListMultipleChargeRequest,
  SelectTaskListMultipleCharge,
  TasksApi,
} from "client";
import { TaskHistoryItem } from "components/Tasks/SelectTaskPanel";
import { Const } from "const";
import { useApiWithTimeout } from "hooks/ApiWrapperWithTimeout";
import { useCallApi } from "hooks/CallApiHook";
import { useState } from "react";

export interface MultipleChargeTaskHistoryItem {
  selectorItem: TaskHistoryItem;
  jobsetInfo: SelectTaskListMultipleCharge;
}
export const useTaskHistory = () => {
  const [request, setTaskHistoryRequest] =
    useState<GetTaskListMultipleChargeRequest>();

  const [api, canceler] = useApiWithTimeout(
    TasksApi,
    Const.operationTimeout.getTaskList
  );

  const result = useCallApi(
    async () => {
      if (request !== undefined) {
        const response = await api.getTaskListMultipleCharge(request);
        if (response === undefined) {
          return [];
        }
        return response.selectTaskInfos?.map((taskInfo) => {
          return {
            selectorItem: {
              jobsetId: taskInfo.jobSetId,
              jobsetName: taskInfo.jobSetName,
              inputDate: taskInfo.inputDate,
            },
            jobsetInfo: taskInfo,
          } as MultipleChargeTaskHistoryItem;
        });
      }
    },
    canceler,
    [request, api, canceler]
  );

  return { ...result, setTaskHistoryRequest };
};
